<template>
  <v-container ref="copyContainer" grid-list-xl fluid>
    <v-layout row wrap>
      <v-overlay :value="pageLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-flex v-if="!pageLoading">
        <filter-stock
          :default-search-params="searchParams"
          :is-component-loading="isRequestingNow"
          @filtering="onFilter"
        ></filter-stock>
        <div v-if="paginatedObject.data && paginatedObject.data.length" class="my-3">
          <v-container>
            <v-layout class="d-flex justify-end px-3 pr-12">
              <table class="tableStockItems">
                <tr>
                  <th>ID</th>
                  <th>{{ $t('general.title') }}</th>
                  <th>{{ $t('general.region') }}</th>
                  <th>{{ $t('general.note') }}</th>
                  <th>{{ $t('general.data') }}</th>
                  <th>{{ $t('general.actions') }}</th>
                </tr>
                <tr :key="stockVendor.id" v-for="stockVendor in paginatedObject.data">
                  <td>{{stockVendor.id}}</td>
                  <td>{{stockVendor.name}}</td>
                  <td>{{ $t('enums.region.' + stockVendor.region) }}</td>
                  <td>{{stockVendor.note}}</td>
                  <td>
                    <div v-if="stockVendor.link">
                      <a :href="stockVendor.link">Ссылка на сайт</a>
                    </div>
                    <div v-if="stockVendor.contact_name">
                      Имя: {{stockVendor.contact_name}}
                    </div>
                    <div v-if="stockVendor.contact_phone">
                      Имя: {{stockVendor.contact_phone}}
                    </div>
                    <div v-if="stockVendor.contact_email">
                      Имя: {{stockVendor.contact_email}}
                    </div>
                  </td>
                  <td class="text-center">
                    <v-btn
                      color="blue"
                      class="ml-2"
                      dark
                      fab
                      x-small
                      @click="$router.push({
                        name: 'stock-vendors.show',
                        params: { item: stockVendor.id },
                        });"
                    >
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                    <v-btn
                      color="black"
                      class="ml-2"
                      dark
                      fab
                      x-small
                      @click="currentStockVendor = stockVendor; isShowDeleteDialog = true"
                    >
                      <v-icon>mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </table>
            </v-layout>
          </v-container>
        </div>
        <pagination-listing
          :pagination-data="paginationData"
          @go-prev="changePage('-')"
          @go-next="changePage('+')"
        ></pagination-listing>
      </v-flex>
      <modal-loading :is-show="isTableLoading"></modal-loading>
      <v-btn
        color="pink"
        dark
        fixed
        bottom
        right
        fab
        @click="$router.push({
          name: 'stock-vendors.show',
          params: { item: 'new' },
          });"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
      <!-- End: Edit Modal -->
      <accept-dialog
        :is-open-dialog="isShowDeleteDialog"
        @on-close="isShowDeleteDialog=false"
        @on-accept="onAcceptDeletion"
      >
        <div class="pt-6">
          {{acceptModalText}}
        </div>
      </accept-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import paginationMixin from '@/mixins/listing/paginationMixin';
import updatePageContentMixin from '@/mixins/updatePageContentMixin';
import defaultListingMixin from '@/mixins/listing/defaultListingMixin';
import ModalLoading from '@/components/loaders/ModalLoading.vue';
import FilterStock from '@/components/listings/FilterStock.vue';
import PaginationListing from '@/components/listings/PaginationListing.vue';
import AcceptDialog from '@/components/AcceptDialog.vue';
import { PER_PAGE_ORDERS } from '@/constants/listing';
import { deepMerge, strReplaceAll } from '@/utils';
import StockVendorProxy from '@/proxies/Stock/StockVendorProxy';

export default {
  name: 'StockVendorListing',
  mixins: [
    paginationMixin,
    updatePageContentMixin,
    defaultListingMixin,
  ],
  components: {
    FilterStock,
    ModalLoading,
    PaginationListing,
    AcceptDialog,
  },
  data() {
    return {
      currentStockVendor: {},
      currentEditableItem: {},
      /* Delete */
      isShowDeleteDialog: false,
      /* Page management */
      pageLoading: false,
      /* Listing management */
      isTableLoading: false,
      searchParams: {
        page: {
          number: 1,
          size: PER_PAGE_ORDERS,
        },
        search_contact: '',
        region: null,
      },
    };
  },
  created() {
    this.isTableLoading = true;
  },
  computed: {
    /* accept modal */
    acceptModalText() {
      return strReplaceAll(this.lang(this.$store, 'sap/listings.global.delete.question'), {
        user: this.currentStockVendor.name,
      });
    },
  },
  methods: {
    fetchData() {
      this.isRequestingNow = true;
      new StockVendorProxy()
        .setParameters(this.searchParams)
        .all()
        .then((response) => {
          this.paginatedObject = response.data.data.items;
          this.$forceUpdate();
        })
        .catch((error) => {
          console.warn(error);
          this.paginatedObject = {};
        })
        .finally(() => {
          this.isTableLoading = false;
          this.isRequestingNow = false;
          this.$store.dispatch('page/finishUpdateCurrentPageContent');
        });
    },
    onPaginatedItemDelete(item) {
      this.currentEditableItem = item;
      this.isShowDeleteDialog = true;
    },
    onAcceptDeletion() {
      this.isRequestingNow = true;
      new StockVendorProxy().destroy(this.currentStockVendor.id)
        .catch((response) => {
          console.error(response);
          alert(`Error: ${response.status}`);
          this.isRequestingNow = false;
        })
        .then(() => {
          this.fetchData();
        });
    },
    onFilter(event) {
      const newSearchParams = Object.assign({}, event);
      this.searchParams = deepMerge(this.searchParams, deepMerge(newSearchParams, {
        page: {
          number: 1,
        },
      }));
    },
    onCloseDialog(item) {
      this.isShowIncomeDialog = false;
      this.isShowExpenseDialog = false;
    },
    onActionDialog(item) {
      this.fetchData();
      this.onCloseDialog();
    },
  },
};
</script>

<style scoped lang="scss">
  .tableStockItems {
    width: 100%;
    border-spacing: 0;

    th {
      border: 1px solid #dddddd;
    }

    td {
      border: 1px solid #dddddd;
      padding: 0 8px;
    }
  }
</style>
